
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    level: 'Level',
    toNextLevel: 'To Next Level',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: 'Deposit {{amount}} coins',
    historyTitle: 'XP History',
    howItWorksTitle: 'How It Works',
    howItWorksFeature1: '{{maxLevel}} levels to unlock',
    howItWorksFeature2: 'Each level requires more XP',
    howItWorksFeature3: 'Complete tasks and stay active to earn XP',
    howItWorksFeature4: 'Get exclusive rewards and take part in activities',
    keyLevels: 'Key Levels',
    xpSourcesTitle: 'How to Earn XP',
    tabActivity: 'Activity',
    tabGameplay: 'Gameplay',
    tabSocial: 'Social',
    rewardsDailyLogin: 'Daily Login',
    rewardsWeeklyStreak: '7-Day Streak',
    rewardsContract: 'Contract Creation',
    rewardsUpgradeSuccess: 'Successful Upgrade',
    rewardsUpgradeFail: 'Failed Upgrade',
    rewardsDrawParticipation: 'Draw Participation',
    rewardsDrawWin: 'Reward from activity',
    rewardsReferralInvite: 'Friend Invitation',
    rewardsReferralDeposit: 'Referral Deposit',
    rewardsCaseBattleWin: 'Case Battle Win',
    rewardsCaseBattleLose: 'Case Battle Loss',
    rewardsRouletteWin: 'Russian Roulette Win',
    rewardsRouletteLose: 'Russian Roulette Loss',
    caseGroupsCheap: 'Cheap Cases',
    caseGroupsMedium: 'Medium Cases',
    caseGroupsExpensive: 'Expensive Cases',
    faqTitle: 'FAQ',
    faqQ1: 'What gives the most XP?',
    faqA1: 'Most XP comes from: opening expensive cases, deposits, draw wins, and inviting active referrals.',
    faqQ2: 'Can I lose my level?',
    faqA2: 'No, your level never drops. XP may be deducted for inactivity, but your achieved level stays with you.',
    faqQ3: 'How to level up faster?',
    faqA3: 'Combine: daily logins, case opening, deposits, inviting friends, and draw participation.',
    faqQ4: 'What does level affect?',
    faqA4: 'Levels give various bonuses: one-time rewards for reaching new levels, permanent privileges, and access to exclusive activities.',
  },
  ru: {
    level: 'Уровень',
    toNextLevel: 'До следующего уровня',
    creditsAbbrevK: 'К',
    creditsAbbrevM: 'М',
    deposit: 'Пополнение {{amount}} монет',
    historyTitle: 'История начислений',
    howItWorksTitle: 'Как работает система',
    howItWorksFeature1: '{{maxLevel}} уровней для прокачки',
    howItWorksFeature2: 'Каждый следующий уровень требует больше XP',
    howItWorksFeature3: 'Выполняй задания и проявляй активность для получения XP',
    howItWorksFeature4: 'Получай эксклюзивные награды за достижения и участвуй в активностях',
    keyLevels: 'Ключевые уровни',
    xpSourcesTitle: 'За что начисляется XP',
    tabActivity: 'Активность',
    tabGameplay: 'Игры',
    tabSocial: 'Друзья',
    rewardsDailyLogin: 'Ежедневный вход',
    rewardsWeeklyStreak: 'Серия входов 7 дней',
    rewardsContract: 'Создание контракта',
    rewardsUpgradeSuccess: 'Успешный апгрейд',
    rewardsUpgradeFail: 'Неудачный апгрейд',
    rewardsDrawParticipation: 'Участие в розыгрыше',
    rewardsDrawWin: 'Награда за активность',
    rewardsReferralInvite: 'Приглашение друга',
    rewardsReferralDeposit: 'Депозит реферала',
    rewardsCaseBattleWin: 'Победа в Case Battles',
    rewardsCaseBattleLose: 'Проигрыш в Case Battles',
    rewardsRouletteWin: 'Победа в русской рулетке',
    rewardsRouletteLose: 'Проигрыш в русской рулетке',
    caseGroupsCheap: 'Дешевые кейсы',
    caseGroupsMedium: 'Средние кейсы',
    caseGroupsExpensive: 'Дорогие кейсы',
    faqTitle: 'Частые вопросы',
    faqQ1: 'Что даёт больше всего XP?',
    faqA1: 'Больше всего XP приносят: открытие дорогих кейсов, пополнения, победы в розыгрышах и приглашение активных рефералов.',
    faqQ2: 'Могу ли я потерять уровень?',
    faqA2: 'Нет, твой уровень никогда не понижается. XP может списываться за неактивность, но достигнутый уровень остается с тобой.',
    faqQ3: 'Как быстрее повысить уровень?',
    faqA3: 'Комбинируй: ежедневный вход, открытие кейсов, пополнения, приглашение друзей и участие в розыгрышах.',
    faqQ4: 'На что влияет уровень?',
    faqA4: 'Уровни дают различные бонусы: разовые награды за достижение новых уровней, постоянные привилегии и доступ к эксклюзивным активностям.',
  },
  uz: {
    level: 'Daraja',
    toNextLevel: 'Keyingi darajagacha',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: '{{amount}} tanga depozit',
    historyTitle: 'XP tarixi',
    howItWorksTitle: 'Qanday ishlaydi',
    howItWorksFeature1: '{{maxLevel}} darajani ochish mumkin',
    howItWorksFeature2: 'Har bir keyingi daraja koʻproq XP talab qiladi',
    howItWorksFeature3: 'Vazifalarni bajaring va XP olish uchun faol boʻling',
    howItWorksFeature4: 'Eksklyuziv mukofotlar oling va faolliklarda qatnashing',
    keyLevels: 'Asosiy darajalar',
    xpSourcesTitle: 'XP qanday olish mumkin',
    tabActivity: 'Faoliyat',
    tabGameplay: 'Oʻyin',
    tabSocial: 'Ijtimoiy',
    rewardsDailyLogin: 'Kunlik kirish',
    rewardsWeeklyStreak: '7 kunlik ketma-ketlik',
    rewardsContract: 'Kontrakt yaratish',
    rewardsUpgradeSuccess: 'Muvaffaqiyatli apgreyd',
    rewardsUpgradeFail: 'Muvaffaqiyatsiz apgreyd',
    rewardsDrawParticipation: 'Qurada qatnashish',
    rewardsDrawWin: 'Faollikda mukofot olish',
    rewardsReferralInvite: 'Doʻstni taklif qilish',
    rewardsReferralDeposit: 'Referal depoziti',
    rewardsCaseBattleWin: 'Keys jangida gʻalaba',
    rewardsCaseBattleLose: 'Keys jangida magʻlubiyat',
    rewardsRouletteWin: 'Rus ruletida gʻalaba',
    rewardsRouletteLose: 'Rus ruletida magʻlubiyat',
    caseGroupsCheap: 'Arzon keyslar',
    caseGroupsMedium: 'Oʻrtacha keyslar',
    caseGroupsExpensive: 'Qimmat keyslar',
    faqTitle: 'Koʻp soʻraladigan savollar',
    faqQ1: 'Eng koʻp XP nima beradi?',
    faqA1: 'Eng koʻp XP: qimmat keyslar ochish, depozitlar, qura gʻalabalari va faol referallarni taklif qilishdan keladi.',
    faqQ2: 'Darajamni yoʻqotishim mumkinmi?',
    faqA2: 'Yoʻq, darajangiz hech qachon tushmaydi. Faolsizlik uchun XP ayirilishi mumkin, lekin erishilgan daraja siz bilan qoladi.',
    faqQ3: 'Qanday tezroq daraja oshirish mumkin?',
    faqA3: 'Birlashtiring: kunlik kirish, keyslar ochish, depozitlar, doʻstlarni taklif qilish va quralarda qatnashish.',
    faqQ4: 'Daraja nimaga taʼsir qiladi?',
    faqA4: 'Darajalar turli bonuslar beradi: yangi darajaga erishganda bir martalik mukofotlar, doimiy imtiyozlar va eksklyuziv faolliklarda qatnashish.',
  },
  fa: {
    level: 'سطح',
    toNextLevel: 'تا سطح بعدی',
    creditsAbbrevK: 'هزار',
    creditsAbbrevM: 'میلیون',
    deposit: '{{amount}} سکه شارژ کن',
    historyTitle: 'تاریخچه XP',
    howItWorksTitle: 'چطور کار می‌کند',
    howItWorksFeature1: '{{maxLevel}} سطح برای باز کردن',
    howItWorksFeature2: 'هر سطح XP بیشتری می‌خواهد',
    howItWorksFeature3: 'کارها را انجام بده و فعال بمان تا XP بگیری',
    howItWorksFeature4: 'جایزه‌های ویژه بگیر و در رویدادها شرکت کن',
    keyLevels: 'سطح‌های کلیدی',
    xpSourcesTitle: 'چطور XP بگیریم',
    tabActivity: 'فعالیت',
    tabGameplay: 'بازی',
    tabSocial: 'اجتماعی',
    rewardsDailyLogin: 'ورود روزانه',
    rewardsWeeklyStreak: 'زنجیره 7 روزه',
    rewardsContract: 'بستن قرارداد',
    rewardsUpgradeSuccess: 'ارتقای موفق',
    rewardsUpgradeFail: 'ارتقای ناموفق',
    rewardsDrawParticipation: 'شرکت در قرعه‌کشی',
    rewardsDrawWin: 'جایزه از فعالیت',
    rewardsReferralInvite: 'دعوت دوست',
    rewardsReferralDeposit: 'شارژ دعوت‌شده',
    rewardsCaseBattleWin: 'برد در نبرد کیس',
    rewardsCaseBattleLose: 'باخت در نبرد کیس',
    rewardsRouletteWin: 'برد در رولت روسی',
    rewardsRouletteLose: 'باخت در رولت روسی',
    caseGroupsCheap: 'کیس‌های ارزان',
    caseGroupsMedium: 'کیس‌های متوسط',
    caseGroupsExpensive: 'کیس‌های گران',
    faqTitle: 'سؤالات پرتکرار',
    faqQ1: 'بیشترین XP از کجا می‌آید؟',
    faqA1: 'بیشترین XP از این‌ها می‌آید: باز کردن کیس‌های گران، شارژ، برد در قرعه‌کشی و دعوت دوستان فعال.',
    faqQ2: 'ممکن است سطحم پایین بیاید؟',
    faqA2: 'نه، سطحت هیچ‌وقت پایین نمی‌آید. برای بی‌فعالیتی ممکن است XP کم شود، اما سطحی که گرفته‌ای مال خودت می‌ماند.',
    faqQ3: 'چطور سریع‌تر سطح بگیرم؟',
    faqA3: 'ترکیب کن: ورود روزانه، باز کردن کیس، شارژ، دعوت دوستان و شرکت در قرعه‌کشی.',
    faqQ4: 'سطح روی چه چیزی اثر دارد؟',
    faqA4: 'سطح‌ها بونوس‌های مختلف می‌دهند: جایزه یک‌باره برای رسیدن به سطح تازه، امتیازهای دائمی و دسترسی به رویدادهای ویژه.',
  },
  pt: {
    level: 'Nível',
    toNextLevel: 'Para o próximo nível',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: 'Depósito de {{amount}} moedas',
    historyTitle: 'Histórico de XP',
    howItWorksTitle: 'Como funciona',
    howItWorksFeature1: '{{maxLevel}} níveis para subir',
    howItWorksFeature2: 'Cada nível seguinte exige mais XP',
    howItWorksFeature3: 'Complete missões e fique ativo para ganhar XP',
    howItWorksFeature4: 'Ganhe recompensas exclusivas e participe das atividades',
    keyLevels: 'Níveis-chave',
    xpSourcesTitle: 'Como ganhar XP',
    tabActivity: 'Atividade',
    tabGameplay: 'Jogos',
    tabSocial: 'Amigos',
    rewardsDailyLogin: 'Login diário',
    rewardsWeeklyStreak: 'Sequência de 7 dias',
    rewardsContract: 'Criação de contrato',
    rewardsUpgradeSuccess: 'Upgrade bem-sucedido',
    rewardsUpgradeFail: 'Upgrade falhou',
    rewardsDrawParticipation: 'Participação em sorteio',
    rewardsDrawWin: 'Recompensa por atividade',
    rewardsReferralInvite: 'Convite de amigo',
    rewardsReferralDeposit: 'Depósito de indicado',
    rewardsCaseBattleWin: 'Vitória em batalha de caixas',
    rewardsCaseBattleLose: 'Derrota em batalha de caixas',
    rewardsRouletteWin: 'Vitória na roleta russa',
    rewardsRouletteLose: 'Derrota na roleta russa',
    caseGroupsCheap: 'Caixas baratas',
    caseGroupsMedium: 'Caixas médias',
    caseGroupsExpensive: 'Caixas caras',
    faqTitle: 'Perguntas frequentes',
    faqQ1: 'O que dá mais XP?',
    faqA1: 'O que mais dá XP: abrir caixas caras, depósitos, vitórias em sorteios e convidar indicados ativos.',
    faqQ2: 'Posso perder meu nível?',
    faqA2: 'Não, seu nível nunca cai. XP pode ser descontado por inatividade, mas o nível alcançado fica com você.',
    faqQ3: 'Como subir de nível mais rápido?',
    faqA3: 'Combine: login diário, abertura de caixas, depósitos, convite de amigos e participação em sorteios.',
    faqQ4: 'No que o nível influencia?',
    faqA4: 'Os níveis dão vários bônus: recompensas únicas por alcançar novos níveis, privilégios permanentes e acesso a atividades exclusivas.',
  },
  tr: {
    level: 'Seviye',
    toNextLevel: 'Sonraki seviyeye',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: '{{amount}} coin yatırma',
    historyTitle: 'XP geçmişi',
    howItWorksTitle: 'Nasıl çalışır',
    howItWorksFeature1: 'Açılacak {{maxLevel}} seviye',
    howItWorksFeature2: 'Her sonraki seviye daha fazla XP ister',
    howItWorksFeature3: 'XP kazanmak için görevleri tamamla ve aktif ol',
    howItWorksFeature4: 'Özel ödüller kazan ve etkinliklere katıl',
    keyLevels: 'Önemli seviyeler',
    xpSourcesTitle: 'XP nasıl kazanılır',
    tabActivity: 'Etkinlik',
    tabGameplay: 'Oyunlar',
    tabSocial: 'Arkadaşlar',
    rewardsDailyLogin: 'Günlük giriş',
    rewardsWeeklyStreak: '7 günlük seri',
    rewardsContract: 'Kontrat oluşturma',
    rewardsUpgradeSuccess: 'Başarılı upgrade',
    rewardsUpgradeFail: 'Başarısız upgrade',
    rewardsDrawParticipation: 'Çekilişe katılım',
    rewardsDrawWin: 'Etkinlik ödülü',
    rewardsReferralInvite: 'Arkadaş daveti',
    rewardsReferralDeposit: 'Davet edilenin yatırması',
    rewardsCaseBattleWin: 'Kasa savaşı zaferi',
    rewardsCaseBattleLose: 'Kasa savaşı yenilgisi',
    rewardsRouletteWin: 'Rus ruletinde zafer',
    rewardsRouletteLose: 'Rus ruletinde yenilgi',
    caseGroupsCheap: 'Ucuz kasalar',
    caseGroupsMedium: 'Orta kasalar',
    caseGroupsExpensive: 'Pahalı kasalar',
    faqTitle: 'Sık sorulan sorular',
    faqQ1: 'En çok XP ne kazandırır?',
    faqA1: 'En çok XP şunlardan gelir: pahalı kasa açmak, bakiye yüklemek, çekiliş kazanmak ve aktif arkadaşlar davet etmek.',
    faqQ2: 'Seviyemi kaybedebilir miyim?',
    faqA2: 'Hayır, seviyen asla düşmez. Hareketsizlik yüzünden XP kesilebilir ama ulaştığın seviye sende kalır.',
    faqQ3: 'Daha hızlı nasıl seviye atlarım?',
    faqA3: 'Hepsini birleştir: günlük giriş, kasa açma, bakiye yükleme, arkadaş davet etme ve çekilişlere katılma.',
    faqQ4: 'Seviye neyi etkiler?',
    faqA4: 'Seviyeler çeşitli bonuslar verir: yeni seviyeye ulaşınca tek seferlik ödüller, kalıcı ayrıcalıklar ve özel etkinliklere erişim.',
  },
  uk: {
    level: 'Рівень',
    toNextLevel: 'До наступного рівня',
    creditsAbbrevK: 'К',
    creditsAbbrevM: 'М',
    deposit: 'Поповнення {{amount}} монет',
    historyTitle: 'Історія нарахувань',
    howItWorksTitle: 'Як працює система',
    howItWorksFeature1: '{{maxLevel}} рівнів для прокачування',
    howItWorksFeature2: 'Кожен наступний рівень потребує більше XP',
    howItWorksFeature3: 'Виконуй завдання й будь активним, щоб отримувати XP',
    howItWorksFeature4: 'Отримуй ексклюзивні нагороди за досягнення та бери участь в активностях',
    keyLevels: 'Ключові рівні',
    xpSourcesTitle: 'За що нараховується XP',
    tabActivity: 'Активність',
    tabGameplay: 'Ігри',
    tabSocial: 'Друзі',
    rewardsDailyLogin: 'Щоденний вхід',
    rewardsWeeklyStreak: 'Серія входів 7 днів',
    rewardsContract: 'Створення контракту',
    rewardsUpgradeSuccess: 'Успішний апгрейд',
    rewardsUpgradeFail: 'Невдалий апгрейд',
    rewardsDrawParticipation: 'Участь у розіграші',
    rewardsDrawWin: 'Нагорода за активність',
    rewardsReferralInvite: 'Запрошення друга',
    rewardsReferralDeposit: 'Депозит реферала',
    rewardsCaseBattleWin: 'Перемога в кейс-батлах',
    rewardsCaseBattleLose: 'Програш у кейс-батлах',
    rewardsRouletteWin: 'Перемога в російській рулетці',
    rewardsRouletteLose: 'Програш у російській рулетці',
    caseGroupsCheap: 'Дешеві кейси',
    caseGroupsMedium: 'Середні кейси',
    caseGroupsExpensive: 'Дорогі кейси',
    faqTitle: 'Часті запитання',
    faqQ1: 'Що дає найбільше XP?',
    faqA1: 'Найбільше XP приносять: відкриття дорогих кейсів, поповнення, перемоги в розіграшах і запрошення активних рефералів.',
    faqQ2: 'Чи можу я втратити рівень?',
    faqA2: 'Ні, твій рівень ніколи не знижується. XP можуть списувати за неактивність, але досягнутий рівень залишається з тобою.',
    faqQ3: 'Як швидше підвищити рівень?',
    faqA3: 'Комбінуй: щоденний вхід, відкриття кейсів, поповнення, запрошення друзів і участь у розіграшах.',
    faqQ4: 'На що впливає рівень?',
    faqA4: 'Рівні дають різні бонуси: разові нагороди за досягнення нових рівнів, постійні привілеї та доступ до ексклюзивних активностей.',
  },
  de: {
    level: 'Level',
    toNextLevel: 'Bis zum nächsten Level',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: 'Einzahlung {{amount}} Münzen',
    historyTitle: 'XP-Verlauf',
    howItWorksTitle: 'So funktioniert’s',
    howItWorksFeature1: '{{maxLevel}} Level zum Freischalten',
    howItWorksFeature2: 'Jedes weitere Level braucht mehr XP',
    howItWorksFeature3: 'Erledige Aufgaben und sei aktiv, um XP zu sammeln',
    howItWorksFeature4: 'Hol dir exklusive Belohnungen für Erfolge und nimm an Aktionen teil',
    keyLevels: 'Wichtige Level',
    xpSourcesTitle: 'So sammelst du XP',
    tabActivity: 'Aktivität',
    tabGameplay: 'Spiele',
    tabSocial: 'Freunde',
    rewardsDailyLogin: 'Täglicher Login',
    rewardsWeeklyStreak: '7-Tage-Serie',
    rewardsContract: 'Contract erstellt',
    rewardsUpgradeSuccess: 'Erfolgreiches Upgrade',
    rewardsUpgradeFail: 'Fehlgeschlagenes Upgrade',
    rewardsDrawParticipation: 'Teilnahme an Verlosung',
    rewardsDrawWin: 'Belohnung für Aktivität',
    rewardsReferralInvite: 'Freund eingeladen',
    rewardsReferralDeposit: 'Einzahlung eines Referrals',
    rewardsCaseBattleWin: 'Case-Battles-Sieg',
    rewardsCaseBattleLose: 'Case-Battles-Niederlage',
    rewardsRouletteWin: 'Sieg beim Russischen Roulette',
    rewardsRouletteLose: 'Niederlage beim Russischen Roulette',
    caseGroupsCheap: 'Günstige Cases',
    caseGroupsMedium: 'Mittlere Cases',
    caseGroupsExpensive: 'Teure Cases',
    faqTitle: 'Häufige Fragen',
    faqQ1: 'Was bringt am meisten XP?',
    faqA1: 'Am meisten XP bringen: teure Cases öffnen, Einzahlungen, Verlosungssiege und aktive Referrals einladen.',
    faqQ2: 'Kann ich mein Level verlieren?',
    faqA2: 'Nein, dein Level sinkt nie. Bei Inaktivität können XP abgezogen werden, aber dein erreichtes Level bleibt.',
    faqQ3: 'Wie steige ich schneller auf?',
    faqA3: 'Kombiniere: täglicher Login, Cases öffnen, Einzahlungen, Freunde einladen und an Verlosungen teilnehmen.',
    faqQ4: 'Was bewirkt das Level?',
    faqA4: 'Level bringen verschiedene Boni: einmalige Belohnungen für neue Level, dauerhafte Vorteile und Zugang zu exklusiven Aktionen.',
  },
  es: {
    level: 'Nivel',
    toNextLevel: 'Hasta el siguiente nivel',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: 'Recarga de {{amount}} monedas',
    historyTitle: 'Historial de XP',
    howItWorksTitle: 'Cómo funciona',
    howItWorksFeature1: '{{maxLevel}} niveles por desbloquear',
    howItWorksFeature2: 'Cada nivel nuevo requiere más XP',
    howItWorksFeature3: 'Completa tareas y mantente activo para ganar XP',
    howItWorksFeature4: 'Consigue premios exclusivos por tus logros y participa en actividades',
    keyLevels: 'Niveles clave',
    xpSourcesTitle: 'Cómo ganar XP',
    tabActivity: 'Actividad',
    tabGameplay: 'Juegos',
    tabSocial: 'Amigos',
    rewardsDailyLogin: 'Acceso diario',
    rewardsWeeklyStreak: 'Racha de 7 días',
    rewardsContract: 'Creación de contrato',
    rewardsUpgradeSuccess: 'Upgrade exitoso',
    rewardsUpgradeFail: 'Upgrade fallido',
    rewardsDrawParticipation: 'Participación en sorteo',
    rewardsDrawWin: 'Premio por actividad',
    rewardsReferralInvite: 'Invitación de un amigo',
    rewardsReferralDeposit: 'Recarga de un referido',
    rewardsCaseBattleWin: 'Victoria en Case Battles',
    rewardsCaseBattleLose: 'Derrota en Case Battles',
    rewardsRouletteWin: 'Victoria en la ruleta rusa',
    rewardsRouletteLose: 'Derrota en la ruleta rusa',
    caseGroupsCheap: 'Cajas baratas',
    caseGroupsMedium: 'Cajas medias',
    caseGroupsExpensive: 'Cajas caras',
    faqTitle: 'Preguntas frecuentes',
    faqQ1: '¿Qué da más XP?',
    faqA1: 'Lo que más XP da: abrir cajas caras, recargas, ganar sorteos e invitar a referidos activos.',
    faqQ2: '¿Puedo perder mi nivel?',
    faqA2: 'No, tu nivel nunca baja. Se puede descontar XP por inactividad, pero el nivel que alcanzaste se queda contigo.',
    faqQ3: '¿Cómo subo de nivel más rápido?',
    faqA3: 'Combina: acceso diario, abrir cajas, recargas, invitar amigos y participar en sorteos.',
    faqQ4: '¿Qué afecta el nivel?',
    faqA4: 'Los niveles dan distintos bonos: premios únicos por llegar a niveles nuevos, privilegios permanentes y acceso a actividades exclusivas.',
  },
  pl: {
    level: 'Poziom',
    toNextLevel: 'Do następnego poziomu',
    creditsAbbrevK: 'K',
    creditsAbbrevM: 'M',
    deposit: 'Doładowanie {{amount}} monet',
    historyTitle: 'Historia XP',
    howItWorksTitle: 'Jak to działa',
    howItWorksFeature1: '{{maxLevel}} poziomów do zdobycia',
    howItWorksFeature2: 'Każdy kolejny poziom wymaga więcej XP',
    howItWorksFeature3: 'Wykonuj zadania i bądź aktywny, żeby zdobywać XP',
    howItWorksFeature4: 'Zdobywaj ekskluzywne nagrody za osiągnięcia i bierz udział w akcjach',
    keyLevels: 'Kluczowe poziomy',
    xpSourcesTitle: 'Za co dostaje się XP',
    tabActivity: 'Aktywność',
    tabGameplay: 'Gry',
    tabSocial: 'Znajomi',
    rewardsDailyLogin: 'Codzienne logowanie',
    rewardsWeeklyStreak: 'Seria 7 dni',
    rewardsContract: 'Utworzenie kontraktu',
    rewardsUpgradeSuccess: 'Udany upgrade',
    rewardsUpgradeFail: 'Nieudany upgrade',
    rewardsDrawParticipation: 'Udział w losowaniu',
    rewardsDrawWin: 'Nagroda za aktywność',
    rewardsReferralInvite: 'Zaproszenie znajomego',
    rewardsReferralDeposit: 'Wpłata polecanego',
    rewardsCaseBattleWin: 'Wygrana w Case Battle',
    rewardsCaseBattleLose: 'Przegrana w Case Battle',
    rewardsRouletteWin: 'Wygrana w rosyjskiej ruletce',
    rewardsRouletteLose: 'Przegrana w rosyjskiej ruletce',
    caseGroupsCheap: 'Tanie skrzynki',
    caseGroupsMedium: 'Średnie skrzynki',
    caseGroupsExpensive: 'Drogie skrzynki',
    faqTitle: 'Częste pytania',
    faqQ1: 'Co daje najwięcej XP?',
    faqA1: 'Najwięcej XP dają: otwieranie drogich skrzynek, doładowania, wygrane w losowaniach i zapraszanie aktywnych poleconych.',
    faqQ2: 'Czy mogę stracić poziom?',
    faqA2: 'Nie, twój poziom nigdy nie spada. XP mogą być odjęte za nieaktywność, ale osiągnięty poziom zostaje z tobą.',
    faqQ3: 'Jak szybciej awansować?',
    faqA3: 'Łącz: codzienne logowanie, otwieranie skrzynek, doładowania, zapraszanie znajomych i udział w losowaniach.',
    faqQ4: 'Na co wpływa poziom?',
    faqA4: 'Poziomy dają różne bonusy: jednorazowe nagrody za nowe poziomy, stałe przywileje i dostęp do ekskluzywnych akcji.',
  },
});
